import { render, staticRenderFns } from "./form-partial-subcontracting.vue?vue&type=template&id=f15ca018"
import script from "./form-partial-subcontracting.vue?vue&type=script&lang=js"
export * from "./form-partial-subcontracting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports